import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'

const { awsAuthConfig } = require('../../aws-auth-config')
const awsAuth = require('../utils/awsAuth')
const withAWSAuth = (WrappedComponent) => {
  awsAuthConfig()
  class AWSAuthProvider extends React.Component {
    render () {
      return (
        <WrappedComponent {...this.props} awsAuth={awsAuth} />
      )
    }
  }

  return hoistNonReactStatics(AWSAuthProvider, WrappedComponent)
}

export default withAWSAuth
